import { useFormContext } from 'react-hook-form';

import Box from '@mui/material/Box';

import ColorCell from '../../../../../Table/TableCell/DataGrid/ColorCell';

export function renderDropDownReadMode<T>({
  name,
  label,
  options,
  valueGetter,
  labelGetter
}: {
  name: string;
  label: string;
  options: T[];
  valueGetter: string;
  labelGetter: string;
}) {
  const { getValues } = useFormContext();

  const selected = options?.find(
    (item) => item[valueGetter] === getValues(name)
  );

  return (
    <Box paddingX={'14px'}>
      <Box sx={{ typography: 'subtitle2' }}>
        <label>{label}</label>
      </Box>
      <Box sx={{ typography: 'h4' }}>{selected && selected[labelGetter]}</Box>
    </Box>
  );
}

export function renderColorReadMode({ name, label }) {
  const { getValues } = useFormContext();

  return (
    <Box paddingX={'14px'}>
      <Box sx={{ typography: 'subtitle2' }}>
        <label>{label}</label>
      </Box>
      <Box sx={{ typography: 'h4' }}>
        <ColorCell value={getValues(name)} />
      </Box>
    </Box>
  );
}
